@if (formInitialized) {
  <form
    [formGroup]="form"
    (ngSubmit)="saveChanges()"
    class="op-form"
    >
    <op-immediate-reminder-settings class="op-form--fieldset" />
    <op-reminder-settings-daily-time class="op-form--fieldset" />
    <op-workdays-settings class="op-form--fieldset" />
    <op-email-alerts-settings class="op-form--fieldset" />
    <div class="op-form--submit">
      <button
        class="button -primary"
        [textContent]="text.save"
        type="submit"
      ></button>
    </div>
  </form>
}
